import { render, staticRenderFns } from "./ModalGenerarCts.vue?vue&type=template&id=298d5fc5"
import script from "./ModalGenerarCts.vue?vue&type=script&lang=js"
export * from "./ModalGenerarCts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports